import React, { Component } from 'react'
import Select from 'react-select';
import MobileMonth from './MobileMonth'

class MobileMonths extends Component{

  render() {
    return(
      <div className="MobileMonths">
        <Select
          styles={{boxShadow: 'none'}}
          onChange={this.props.handleChange}
          isSearchable={false}
          value={this.props.formOptions[this.props.theMonth - 1]}
          components={{ Option: MobileMonth }}
          options={this.props.formOptions}
          />
      </div>
    )
  }
}

export default MobileMonths



// WEBPACK FOOTER //
// ./src/components/MobileMonths.jsx